import { RasterLayerDTO } from 'common/defines/analytic';
import { LayerTypeEnum, listFixedRasters } from 'common/defines/constants';
import configs from 'constants/config';
import { Layer, Source } from 'react-map-gl';
import { useAppSelector } from 'store/hooks';
import { mapViewSelector } from 'store/slices/mapViewSlice';
import IntermediateLayers from './IntermediateLayers';

const RasterLayers = () => {
  const { layerTypeList, layerTypeCurrentList } = useAppSelector(mapViewSelector);
  const layerList = layerTypeCurrentList.filter((item) => item.layerType);

  const renderBeforeId = (item: RasterLayerDTO) => {
    const isFixedRaster = listFixedRasters.includes(item.layerType as LayerTypeEnum);
    const isCustomRaster = !!item.orderNumber;
    const isAnalyticRaster = !isFixedRaster && !isCustomRaster;

    if (isAnalyticRaster) return 'analytic-layer';
    else if (isCustomRaster) return 'foreground-layer';
    else return 'background-layer';
  };

  return (
    <>
      <IntermediateLayers />
      {layerList?.map((_item, index: number) => {
        return (
          <Source
            key={`raster-${_item.analysisId._id}-${_item.analysisId.name}-${_item.layerType}`}
            id={`raster-${_item.analysisId._id}-${_item.analysisId.name}-${_item.layerType}`}
            type="raster"
            tiles={[
              `${configs.API_DOMAIN}/data-analytics/getPathDataAnalysisDefault/${_item.analysisId._id}/{z}/{x}/{y}.png?layerType=${_item.layerType}`,
            ]}>
            <Layer
              id={`raster-${index}`}
              beforeId={renderBeforeId(_item)}
              type="raster"
              layout={{
                visibility: layerTypeList.some((_i: any) => _i.layerType === _item.layerType) ? 'visible' : 'none',
              }}
            />
          </Source>
        );
      })}
    </>
  );
};

export default RasterLayers;
